<template>
  <transition name="fade">
    <div class="c-modal-backdrop">
      <div class="c-modal" role="dialog" aria-labelledby="modalTitle" aria-describedby="modalDescription" :class="maxWidth">
        <header class="c-modal-header" id="modalTitle" v-if="hasHeader">
          <button type="button" class="c-btn-close" @click="close" aria-label="Close modal"><i class="icon-close-rounded-outline"></i></button>
          <slot name="header">
            <p class="c-modal-header__title">Título por defecto</p>
          </slot>
        </header>
        <section class="c-modal-body" id="modalDescription" v-if="hasBody">
          <slot name="body">
            <p>
              Body por defecto
            </p>
          </slot>
        </section>
        <footer class="c-modal-footer" v-if="hasFooter">
          <slot name="footer">
            <button type="button" class="secondary-button" @click="close" aria-label="Close modal">
              Cancelar
            </button>
            <button type="button" class="button btn-primary" @click="close" aria-label="Close modal">
              Aceptar
            </button>
          </slot>
        </footer>
      </div>
    </div>
  </transition>
</template>

<script>
    export default {
        name: 'Modal',
        props: {
            maxWidth: String,
        },
        methods: {
            close() {
                this.$emit('close');
            },
        },
        computed: {
            hasHeader() {
                return !!this.$slots.header
            },
            hasBody() {
                return !!this.$slots.body
            },
            hasFooter() {
                return !!this.$slots.footer
            }
        }
    };
</script>

<style lang="scss">
  .fade-enter-active, .fade-leave-active {
    transition: opacity .5s;
  }
  .fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
    opacity: 0;
  }
  .c-modal-backdrop {
    overflow: hidden;
    position:fixed;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    background-color: rgba(0, 0, 0, 0.7);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 10000;
  }

  .c-modal {
    background: white;
    box-shadow: 2px 2px 20px 1px;
    overflow-x: auto;
    display: flex;
    flex-direction: column;
    -ms-overflow-style: none;
    overflow: auto;
    border-radius: 4px;
    max-height: 85vh;
  }

  .c-modal-body,
  .c-modal-header,
  .c-modal-footer{
    padding-left: 24px;
    padding-right: 24px;
  }

  .c-modal-header {
    display: flex;
    flex-direction: column;
    color: #4A4A4A;
    align-items: center;
    padding-top: 20px;
    padding-bottom: 0px;

    .c-btn-close {
      border: none;
      font-size: 24px;
      font-weight: 400 !important;
      width: 29px;
      height: 29px;
      padding: 0;
      cursor: pointer;
      font-weight: bold;
      color: #005a83;
      background: transparent;
      margin-left: auto;
    }

    &__title,
    b, p, h1, h2, h3, h4, span {
      margin: 0 !important;
      margin-right: auto !important;
      font-size: 18px !important;
      font-weight: bold !important;
      line-height: 1.28 !important;
      letter-spacing: 0.4px !important;
    }
  }

  .c-modal-body {
    position: relative;
    padding-top: 20px;
    padding-bottom: 20px;

    p {
      font-size: 14px !important;
    }

    b {
      font-size: 16px !important;
      margin: 16px 0 !important;
    }
  }

  .c-modal-footer {
    display: flex;
    justify-content: flex-end;
    display: inherit;
    padding-top: 16px;
    padding-bottom: 16px;
    border-top: 1px solid #eeeeee;
    width: 100%;
    min-height: auto;
    background: white;

    button {
      max-width: 50% !important;
      font-size: 15px !important;
      padding: 8px 30px !important;
      font-weight: 500 !important;
      &:first-child {
        margin-right: 20px;
      }
    }
  }

  @media only screen and (max-width: 992px) {
    .c-modal-footer {
      flex-wrap: wrap;
    }

    .c-modal-footer button {
      max-width: 100% !important;
    }
    .c-modal-footer button:first-child {
      margin-right: 0;
      order: 2;
    }
    .c-modal-footer button:nth-child(2) {
      margin-bottom: 15px;
      // margin-top: 1em;
    }
  }

  @media all and (-ms-high-contrast: none), (-ms-high-contrast: active) {
    .c-modal-footer {
      button {
        max-width: 48% !important;
      }
    }
  }
</style>
